import { Gender, IdType } from "./order";

export interface ApiResponse<T = unknown> {
  code?: number;
  message?: string;
  data?: T;
  [property: string]: any;
}

export type FileUpload = {
  /**
   * 附件名称
   */
  name?: string;
  /**
   * 订单ID
   */
  orderId?: number;
  /**
   * 附件路径
   */
  path?: string;
  /**
   * 附件类型
   */
  type?: FileType;
  [property: string]: any;
};

/**
 * 附件类型
 */
export enum FileType {
  AddressProof = "ADDRESS_PROOF",
  Aml = "AML",
  FinancialData = "FINANCIAL_DATA",
  InsuredIDBack = "INSURED_ID_BACK",
  InsuredIDFront = "INSURED_ID_FRONT",
  InsuredPassportBack = "INSURED_PASSPORT_BACK",
  InsuredPassportFront = "INSURED_PASSPORT_FRONT",
  MedicalReport = "MEDICAL_REPORT",
  OtherInfo = "OTHER_INFO",
  PolicyholderHkEntrySlip = "POLICYHOLDER_HK_ENTRY_SLIP",
  PolicyholderIDBack = "POLICYHOLDER_ID_BACK",
  PolicyholderIDFront = "POLICYHOLDER_ID_FRONT",
  PolicyholderPassportBack = "POLICYHOLDER_PASSPORT_BACK",
  PolicyholderPassportFront = "POLICYHOLDER_PASSPORT_FRONT",
  PersonalPIEvaluationForm = "PERSONAL_PI_EVALUATION_FORM",
  OrderAuditAttachment = "ORDER_AUDIT_ATTACHMENT",
  RiskEvaluationFormAttachment = "RISK_EVALUATION_FORM_ATTACHMENT",
  CraBrokerReport = "CRA_BROKER_REPORT",
  CraFinancialQuestionnaire = "CRA_FINANCIAL_QUESTIONNAIRE",
  CraPremiumPaymentProof = "CRA_PREMIUM_PAYMENT_PROOF",
  CraAssetIncomeProof = "CRA_ASSET_INCOME_PROOF",
  CraThiredPartyRelaTionShipCertificate = "CRA_THIRD_PARTY_RELATIONSHIP_CERTIFICATE",
}

/**
 * 附件类型
 */
export enum Type {
  AddressProof = "ADDRESS_PROOF",
  Aml = "AML",
  FinancialData = "FINANCIAL_DATA",
  InsuredIDBack = "INSURED_ID_BACK",
  InsuredIDFront = "INSURED_ID_FRONT",
  InsuredPassportBack = "INSURED_PASSPORT_BACK",
  InsuredPassportFront = "INSURED_PASSPORT_FRONT",
  MedicalReport = "MEDICAL_REPORT",
  OtherInfo = "OTHER_INFO",
  PolicyholderHkEntrySlip = "POLICYHOLDER_HK_ENTRY_SLIP",
  PolicyholderIDBack = "POLICYHOLDER_ID_BACK",
  PolicyholderIDFront = "POLICYHOLDER_ID_FRONT",
  PolicyholderPassportBack = "POLICYHOLDER_PASSPORT_BACK",
  PolicyholderPassportFront = "POLICYHOLDER_PASSPORT_FRONT",
}

/**
 * 保单附件类型
 */
export enum PolicyAttachmentType {
  AddressProof = "ADDRESS_PROOF",
  Aml = "AML",
  CraAssetIncomeProof = "CRA_ASSET_INCOME_PROOF",
  CraBrokerReport = "CRA_BROKER_REPORT",
  CraFinancialQuestionnaire = "CRA_FINANCIAL_QUESTIONNAIRE",
  CraPremiumPaymentProof = "CRA_PREMIUM_PAYMENT_PROOF",
  CraThirdPartyRelationshipCertificate = "CRA_THIRD_PARTY_RELATIONSHIP_CERTIFICATE",
  FinancialData = "FINANCIAL_DATA",
  InsuredHkEntrySlip = "INSURED_HK_ENTRY_SLIP",
  InsuredIDBack = "INSURED_ID_BACK",
  InsuredIDFront = "INSURED_ID_FRONT",
  InsuredPassportBack = "INSURED_PASSPORT_BACK",
  InsuredPassportFront = "INSURED_PASSPORT_FRONT",
  MedicalReport = "MEDICAL_REPORT",
  OrderAuditAttachment = "ORDER_AUDIT_ATTACHMENT",
  OtherInfo = "OTHER_INFO",
  PersonalPiEvaluationForm = "PERSONAL_PI_EVALUATION_FORM",
  PolicyCompensationFile = "POLICY_COMPENSATION_FILE",
  PolicyFile = "POLICY_FILE",
  PolicyFirstPaymentRecordFile = "POLICY_FIRST_PAYMENT_RECORD_FILE",
  PolicyInsuranceFile = "POLICY_INSURANCE_FILE",
  PolicyOtherFile = "POLICY_OTHER_FILE",
  PolicyServicingFile = "POLICY_SERVICING_FILE",
  PolicySubsequentPaymentRecordFile = "POLICY_SUBSEQUENT_PAYMENT_RECORD_FILE",
  PolicyUnderwritingFile = "POLICY_UNDERWRITING_FILE",
  PolicyholderHkEntrySlip = "POLICYHOLDER_HK_ENTRY_SLIP",
  PolicyholderIDBack = "POLICYHOLDER_ID_BACK",
  PolicyholderIDFront = "POLICYHOLDER_ID_FRONT",
  PolicyholderPassportBack = "POLICYHOLDER_PASSPORT_BACK",
  PolicyholderPassportFront = "POLICYHOLDER_PASSPORT_FRONT",
  RiskEvaluationFormAttachment = "RISK_EVALUATION_FORM_ATTACHMENT",
}

export type OrderAttachmentDTO = {
  /**
   * 订单ID
   */
  orderId?: number;
  /**
   * 附件token
   */
  token?: string;
  /**
   * 附件类型
   */
  type?: Type;
  [property: string]: any;
};

/**
 * 保单附件 DTO
 */
export type PolicyAttachmentDTO = {
  /**
   * 订单ID
   */
  orderId?: number;
  /**
   * 附件token
   */
  token?: string;
  /**
   * 附件类型
   */
  type?: PolicyAttachmentType;
  [property: string]: any;
};

/**
 * beefintech.ifa.user.domain.job.JobMetadata
 *
 * JobMetadata
 */
export interface JobMetadata {
  id?: number;
  name?: string;
  [property: string]: any;
}

/**
 * beefintech.ifa.user.domain.job.JobRankMetadata
 *
 * JobRankMetadata
 */
export interface JobRankMetadata {
  id?: number;
  jobId?: number;
  level?: number;
  name?: string;
  [property: string]: any;
}

/**
 * beefintech.ifa.base.basic.domain.vo.MetadataVO.SelectionMetadata
 *
 * SelectionMetadata
 */
export interface SelectionMetadata {
  children?: SelectionMetadata[];
  key?: string;
  name?: string;
  [property: string]: any;
}

/**
 * beefintech.ifa.commons.domain.system.FormRequiredConfig
 *
 * FormRequiredConfig
 */
export type FormRequiredConfig = {
  /**
   * 基础字段配置
   */
  base?: BaseRequiredField[];
  /**
   * 表单唯一标识
   */
  key?: string;
  /**
   * 联动必填规则列表
   */
  rules?: FieldLinkageRule[];
  [property: string]: any;
};

/**
 * beefintech.ifa.commons.domain.system.FormRequiredConfig.BaseRequiredField
 *
 * BaseRequiredField
 */
export type BaseRequiredField = {
  /**
   * 应用ID列表
   */
  apps?: string[];
  
  defaultValue?: string;
  /**
   * 字段业务名称
   */
  name?: string;
  /**
   * 嵌套字段路径
   */
  path?: string;
  /**
   * 是否基础必填
   */
  required?: boolean;
  [property: string]: any;
};

/**
 * beefintech.ifa.commons.domain.system.FormRequiredConfig.FieldLinkageRule
 *
 * FieldLinkageRule
 */
export type FieldLinkageRule = {
  /**
   * 目标字段列表
   */
  fields?: BaseRequiredField[];
  /**
   * 触发联动的源字段
   */
  source?: string;
  /**
   * 联动条件类型
   */
  type?: string;
  /**
   * 联动条件值
   */
  value?: string;
  [property: string]: any;
};

/**
 * beefintech.ifa.base.basic.domain.vo.MetadataVO.SelectMetadataVO
 *
 * SelectMetadataVO
 */
export interface SelectMetadataVO {
  code?: string;
  items?: SelectionMetadata[];
  [property: string]: any;
}

/**
 * 会面地点显示字段配置
 */
export interface AppointmentLocationShowField {
  field: string; // 字段名，如 "isMeetingRoom", "meetingRoom", "appointmentAddress"
  type?: "input" | "select"; // 字段类型
  items?: string[]; // 当 type 为 select 时的选项列表
}

/**
 * 会面地点配置
 */
export interface AppointmentLocationConfig {
  name: string; // 地点名称
  show?: AppointmentLocationShowField[]; // 需要显示的字段配置
}


export interface PolicySyncFieldConfigItem {
  company?: string;
  field?: string;
  type?: string;
  [property: string]: any;
}

export interface PolicySyncFieldConfig {
  config?: PolicySyncFieldConfigItem[];
  field?: string;
  name?: string;
  type?: string;
  [property: string]: any;
}

/**
 * beefintech.ifa.base.basic.domain.vo.MetadataVO
 *
 * MetadataVO
 */
export interface MetadataVO {
  appointmentLocation?: AppointmentLocationConfig[];
  craVersion?: string;
  fnaVersion?: string;
  formRequiredConfig?: FormRequiredConfig[];
  jobMetadataList?: JobMetadata[];
  jobRankMetadataList?: JobRankMetadata[];
  policySyncFieldConfig?: PolicySyncFieldConfig[];
  selectMetadataList?: SelectMetadataVO[];
  tenantName?: string;
  [property: string]: any;
}

export interface IdCardIdentifyRequest {
  /**
   * 文件
   */
  file?: string;
  /**
   * UNKNOWN :待确认
   * ID_CARD :居民身份证
   * HONGKONG_ID :香港身份证
   * TAIWAN_ID :台湾身份证
   * PASSPORT :护照
   * BIRTH_CERTIFICATE :出生证
   * MACAO_ID :澳门身份证
   * HK_MACAU_PASS :港澳通行证
   */
  idType?: IdType;
  /**
   * 文件base64，和file二选一
   */
  imageBase64?: string;
  [property: string]: any;
}

export interface CertificateInfoVO {
  /**
   * 地址
   */
  address?: string;
  /**
   * 生日
   */
  birthDate?: string;
  /**
   * 国家
   */
  country?: string;
  /**
   * 中文名
   */
  firstnameCn?: string;
  /**
   * 英文名
   */
  firstnameEn?: string;
  /**
   * 性别
   */
  gender?: Gender;
  /**
   * 证件号
   */
  idNumber?: string;
  /**
   * 中文姓
   */
  lastnameCn?: string;
  /**
   * 英文姓
   */
  lastnameEn?: string;
  /**
   * 中文姓名
   */
  nameCn?: string;
  /**
   * 英文姓名
   */
  nameEn?: string;
  /**
   * 证件类型
   */
  type?: string;
  [property: string]: any;
}

/**
 * 是否需要定位的响应
 */
export interface NeedLocateVO {
  /**
   * 是否需要定位
   * true: 需要调用定位功能
   * false: 不需要定位，默认为香港
   */
  needLocate?: boolean;
  [property: string]: any;
}
